export default {"src":"/_next/static/media/suitcase.2b5fbd04.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};